/*jshint -W030 */

import React from 'react';
import loaderSrc  from '../../assests/831.gif';

const Loader = props => (
 <div>
    <img
    style = {{width:75}}
    alt="Loader icon"
    src={loaderSrc} />
</div>
);

export default Loader;